import { Button, Text, useNetworkState } from '@lbcamden/lib-react';
import { FunctionComponent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import { routes } from '~/client/config/routes';
import { useHandleAuth } from '~/client/hooks/authHooks';
import { useCurrentUser } from '~/client/hooks/storeHooks';
import { signIn } from '~/client/lib/auth';
import { useAppStore } from '~/client/store/app/appStore';

import { SplashPage } from '../SplashPage';
import { AppUnavailable } from './AppUnavailable';

export const LoginPage: FunctionComponent = () => {
  const { online } = useNetworkState();

  const navigate = useNavigate();

  const currentUser = useCurrentUser();

  const loginRedirectUri = useAppStore((state) => state.loginRedirectUri);
  const setLoginRedirectUri = useAppStore((state) => state.setLoginRedirectUri);

  const [authFailed, setAuthFailed] = useState(false);

  const { handleAuth, authenticating, username } = useHandleAuth({
    onAuthFailure: () => setAuthFailed(true),
  });

  const heading = username ? 'Welcome back!' : 'Welcome!';
  const message = username
    ? 'Please sign in using your chosen authentication method below.'
    : 'Please sign in using your Camden account.';

  const handleSignIn = () => signIn(loginRedirectUri);

  useEffect(() => {
    if (currentUser) {
      void navigate(loginRedirectUri || routes.home, { replace: true });
      setLoginRedirectUri(undefined);
    }
  }, [currentUser]);

  useEffect(() => {
    if (authFailed) {
      handleSignIn();
    }
  }, [authFailed]);

  const footerContent = username && online && (
    <>
      <Text variant="body2" $color="textSecondary">{`Not ${username}?`}</Text>
      <Button $variant="tertiary" $color="primary" onClick={handleSignIn}>
        Sign in as another user
      </Button>
    </>
  );

  return (
    <SplashPage footerContent={footerContent}>
      {online ? (
        <>
          <Text variant="h1">{heading}</Text>
          <Text variant="lead">{message}</Text>
          <Button loading={authenticating} onClick={handleAuth}>
            Sign in
          </Button>
        </>
      ) : (
        <AppUnavailable />
      )}
    </SplashPage>
  );
};
